module.exports = __webpack_public_path__ + "assets/img/forum1.36bc42dc.png";